export enum HandlerRealTimeProp {
  Message = 'message',
  StepId = 'stepId',
  Close = 'close',
}
